import distantHero from "../static/images/distant_amp/fleshweaver.webp";

// Update the source and dimensions here to change every ToneSuite - Distant hero,
// including store compositions, bundle sections, and social previews.
export const DISTANT_HERO = {
  src: distantHero,
  width: 2560,
  height: 1728,
};
